import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/door-access/control-hubs/retrofit-hub.png";
import type { Product } from "../../types";
import { doorAccessControlHubs } from "../product-list-groups/doorAccessControlHubs";
import { accessPowerMethod } from "../properties/accessPowerMethod";
import { inputTerminals } from "../properties/inputTerminals";
import { outputRelays } from "../properties/outputRelays";
import { poePorts } from "../properties/poePorts";
import { powerRedundancy } from "../properties/powerRedundancy";

export const retrofitHub: Product = {
  id: "retrofitHub",
  productTitle: "Retrofit Hub",
  description: "retrofitHub.description",
  productListGroup: doorAccessControlHubs,
  techspecsPath: [SiteId.TechSpecs, "/unifi/door-access/ua-retrofit-hub-2"],
  storePathParts: {
    category: "all-door-access",
    productSlug: "ua-retrofit-hub-2",
  },
  descriptionMaxWidth: 247,
  isNew: true,
  image: { src: image, width: 200, height: 160 },
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '140 x 120 x 45 mm\n(5.5 x 4.7 x 1.8")',
      },
    },
    {
      propertyId: outputRelays.id,
      value: {
        type: "translation",
        value: "retrofitHub.outputRelays",
      },
    },
    {
      propertyId: inputTerminals.id,
      value: {
        type: "translation",
        value: "retrofitHub.inputTerminals",
      },
    },
    {
      propertyId: poePorts.id,
      value: {
        type: "boolean",
        value: false,
      },
    },
    {
      propertyId: accessPowerMethod.id,
      value: {
        type: "translation",
        value: "retrofitHub.powerMethod",
      },
    },
    {
      propertyId: powerRedundancy.id,
      value: { type: "boolean", value: false },
    },
  ],
};
